import React from 'react';

const About = () => {
  return (
    <div className="about">
      <h2>About Page</h2>
      <p>Learn more about the Classifi Chat App.</p>
    </div>
  );
};

export default About;
